import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { checkUserPermission } from "../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useMemo } from "react";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../common/common";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";

function PaymentLog() {
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const [formValues, setFormValues] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [searchtext, setSearchText] = useState("");
  const [sortingId, setSortingId] = useState(1); //currentorder
  const [sortingDirection, setSortingDirection] = useState("desc"); // ordercolumn

  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [selectSupplier, setSelectSupplier] = useState(0);
  const [selectEmployee, setSelectEmployee] = useState(0);
  const [customer, setCustomer] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(0);
  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);
  const [selectTransaction, setSelectTransaction] = useState(1);

  const [customeDate, setCustomDate] = useState(8);

  const [showSupplierSelect, setShowSupplierSelect] = useState(true);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);
  const [ShowEmployeeSelect, setShowEmployeeSelect] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  let PERMISSION_EDIT = "edit-transaction-log";

  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const startLast7DayDate = moment()
    .subtract(6, "days")
    .startOf("day")
    .format("YYYY-MM-DD");
  const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");

  const [beginningDate, setBeginningDate] = useState(startLast7DayDate);

  console.log(beginningDate, "beginningDate------>");
  const [finalDate, setFinalDate] = useState(endLast7DayDate);

  useEffect(() => {
    if (customeDate === 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    }
  }, []);

  const navigate = useNavigate();

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const dateOptions = [
    { label: "Select", value: 0 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    { label: "Last 7 Day", value: 8 },
  ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <>
              <Box
                component="span"
                sx={(theme) => ({
                  borderRadius: "0.3rem",
                  color: "#343f62",
                  maxWidth: "18ch",
                  fontWeight: "700",
                  textDecoration: "underline",
                  textUnderlineOffset: "3px",
                  p: "0.3rem",
                  cursor: "pointer",
                })}
              >
                {row?.original?.Type === "Expense" ? (
                  <Link
                    to={`/Expense/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "RECEIVINGS" ? (
                  <Link
                    to={`/manage-receiving/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "DEPOSIT" ? (
                  <Link
                    to={`/bank-deposit/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "TRANSFER" ? (
                  <Link
                    to={`/manage-transfer/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "JOURNAL" ? (
                  <Link
                    to={`/journal-entry/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "PAYBILLS" ? (
                  <Link
                    to={`/receiving-paybills/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "RECEIVEPAYMENT" ? (
                  <Link
                    to={`/receive-payment/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "SALES" ? (
                  <Link
                    to={`/sales-receipt/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : (
                  <div>{row?.original.ID}</div>
                )}
              </Box>
            </>
          )
        : null,
    },
    {
      header: "CREATED ON",
      accessorKey: "CreatedOn",
      Cell: ({ row }) =>
        moment(row.original.CreatedOn).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "DATE",
      accessorKey: "Date",
      Cell: ({ row }) =>
        row.original.Date == "0000-00-00" ||
        row.original.Date == "" ||
        row.original.Date == null
          ? ""
          : moment(row.original.Date).format("MM/DD/YYYY"),
    },
    {
      header: "TYPE",
      accessorKey: "Type",
      size: 130,
    },
    {
      header: " BILL / REF NO.",
      accessorKey: "No",
      size: 130,
    },
    {
      header: "CONTACT",
      accessorKey: "Contact",
      size: 120,
      Cell: ({ row }) => (
        <>
          {row?.original.IsSupplier === 1 && row?.original.SupCusId !== null ? (
            <Link
              to={`/manage-suppliers/${row?.original.SupCusId}`}
              style={{
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              }}
            >
              {row?.original.Contact}
            </Link>
          ) : row?.original.IsSupplier === 2 &&
            row?.original.SupCusId !== null ? (
            <Link
              to={`/manage-customers/${row?.original.SupCusId}`}
              style={{
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              }}
            >
              {row?.original.Contact}
            </Link>
          ) : (
            <div>{row?.original.Contact}</div>
          )}
        </>
      ),
    },
    {
      header: "MEMO/DESC.",
      size: 100,
      accessorKey: "Memo",
    },
    {
      header: "DUE DATE",
      accessorKey: "DueDate",
      Cell: ({ row }) => {
        return row?.original?.DueDate == null ||
          row?.original?.DueDate == "00-00-0000" ||
          row?.original?.DueDate == ""
          ? ""
          : moment(row?.original?.DueDate).format("MM/DD/YYYY");
      },
    },
    {
      header: "AMOUNT/CREDIT",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div>
            <p>{parseFloat(row?.original?.Amount).toFixed(2)}</p>
            {/* <p>Credit: {parseFloat(row?.original?.Credit).toFixed(2)}</p> */}
            {row?.original?.Credit == 0 ? (
              ""
            ) : (
              <>
                <p>Credit: {parseFloat(row?.original?.Credit).toFixed(2)}</p>
              </>
            )}
          </div>
        );
      },
    },
    {
      header: "CREDIT USED",
      accessorKey: "CreditUsed",
      size: 120,
      Cell: ({ row }) => {
        return parseFloat(row?.original?.CreditUsed).toFixed(2);
      },
    },
    {
      header: "MODIFIED",
      accessorKey: "LastModifiedDate",
      Cell: ({ row }) => {
        return row?.original?.LastModifiedDate == null
          ? ""
          : moment(row?.original?.LastModifiedDate).format("MM/DD/YYYY h:mm A");
      },
    },
    {
      header: "QB SYNC STATUS",
      accessorKey: "SyncStatus",
      size: 120,
      Cell: ({ row }) => {
        if (row.original.SyncStatus === "Complete") {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--success-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else if (
          row.original.SyncStatus === "Failed" &&
          row.original.StatusName !== "Opening Balance"
        ) {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--error-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else {
          return null;
        }
      },
    },
  ]);

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  //Date

  //Today

  // Option Set Date
  const handleDateFilter = (event) => {
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == 8) {
      setBeginningDate(startLast7DayDate);
      setFinalDate(endLast7DayDate);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  //starting Date
  // const handleDate = (event) => {
  //   console.log(event, "From:------>")
  //   const datetime = (event);
  //   const settime = moment(datetime).format("YYYY-MM-DD")
  //   console.log(settime , "settime")
  //   setBeginningDate(settime);
  //   // setBeginningDate (moment(event?.target?.value).format('YYYY-MM-DDT00:00:00.000') + 'Z');
  //   setCustomDate(7);
  // };

  const handleDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setBeginningDate(selectedDate);
      setCustomDate(7);
    }
  };

  const handleEndDate = (selecttime) => {
    if (selecttime && selecttime.length > 0) {
      // const datetime =
      //   moment(selecttime[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      setFinalDate(selecttime);
      setCustomDate(7);
    }
  };

  //End Date
  // const handleEndDate = (event) => {
  //   console.log(event, "eventeventeventeventeventevent")
  //   setFinalDate(event?.target?.value);
  //   // setFinalDate (moment(event?.target?.value).format('YYYY-MM-DDT00:00:00.000') + 'Z');
  //   setCustomDate(7);
  // };

  useEffect(() => {
    SupplierAPI();
    CustomerAPI();
    EmployeesAPI();
    transactionType();
  }, []);

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      selectEmployee,
      sortingId, //currentorder
      sortingDirection, //ordercolumn,
      searchtext,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    selectTransaction,
    beginningDate,
    finalDate,
    selectCustomer,
    selectSupplier,
    selectEmployee,
    searchtext, //
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const SupplierAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        // setSupplier([
        //   { FirstName: "Select Supplier", ID: 0 },
        //   ...response.data.ResponseData,
        // ]);
        setSupplier(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // setLoading(true);
        setCustomer(res.data.ResponseData);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const EmployeesAPI = () => {
    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData, "setEmployees");
        // setLoading(true);
        setEmployees(res.data.ResponseData);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const transactionType = () => {
    //payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setTransactionTypeDropdown(res.data.ResponseData);
        // console.log("res280", res.data.ResponseData);
      });
  };

  // const paymentDetailsAPI = () =>{

  // }

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      e.id, //currentorder
      sortingDirection, //ordercolumn,
      searchtext
    );
  };

  const handleListData = (
    pagenumber,
    pagesize,
    transactiontype,
    beginningDate,
    finalDate,
    customerid,
    supplierid,
    Employeesid,
    currentorder,
    ordercolumn,
    searchtext,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    beginningDate =
      beginningDate == undefined
        ? ""
        : beginningDate == null
        ? ""
        : beginningDate;
    finalDate =
      finalDate == undefined ? "" : finalDate == null ? "" : finalDate;

    console.log("angel", columnFilters, globalFilter, pagination, sorting);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    setLoading(true);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/transactionpaymentlog?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&transactiontype=${transactiontype}&supplierid=${supplierid}&customerid=${customerid}&Employeesid=${Employeesid}&locationid=${locationId}&startdate=${beginningDate}&enddate=${finalDate}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("uis here", res);

        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setFormValues(res.data.ResponseData?.list);
        setData(res.data.ResponseData?.list);
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  //Supplier Dropdown
  let supplierTypeDropdownOption = [];
  const termpsupplierlist = supplier.filter((u, i) => {
    supplierTypeDropdownOption[i] = {
      // label: u.FirstName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.ID,
    };
  });

  //Customer Dropdown
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.Id,
    };
  });

  let EmployeesOption = [];
  const EmployeesDropdown = Employees.map((u, i) => {
    EmployeesOption[i] = {
      label: u.Name,
      value: u.eID,
    };
  });
  //TransactionType Dropdown
  let transactionTypeDropdownOption = [];
  const transactionDropdown = transactionTypeDropdown?.map((u, i) => {
    transactionTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const selectTransactionHandle = async (event) => {
    console.log(event, "584event value after click");
    setSelectTransaction(event == undefined ? 1 : event);
  };

  const radioClickSupplierHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");

    setShowCustomerSelect(false);
    setShowSupplierSelect(true);
    setShowEmployeeSelect(false);
  };

  const radioClickempolyeHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");

    setShowCustomerSelect(false);
    setShowSupplierSelect(false);
    setShowEmployeeSelect(true);
  };
  const radioClickCustomerHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");
    setShowSupplierSelect(false);
    setShowCustomerSelect(true);
    setShowEmployeeSelect(false);
  };

  const selectSupplierHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectSupplier(event == undefined ? 0 : event);
    setSelectCustomer(0);
    setSelectEmployee(0);
  };

  const selectCustomerHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectCustomer(event == undefined ? 0 : event);
    setSelectSupplier(0);
    setSelectEmployee(0);
  };

  const selectEmployeeHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectEmployee(event == undefined ? 0 : event);
    setSelectSupplier(0);
    setSelectCustomer(0);
  };
  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      sortingId, //currentorder
      sortingDirection, //ordercolumn
      searchtext
    );
  };

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_Report.xlsx`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      sortingId, //currentorder
      sortingDirection, //ordercolumn
      searchtext
    );
  };

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  console.log(data, "data==>");

  const downloadPDF = (rows, field) => {
    setLoading(true);

    let newData = [];
    if (field === "selectedRow") {
      newData = rows.map((row) => row.original);
    } else if (field === "allData") {
      newData = data;
    }

    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(newData.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(newData[index - 1].DueDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(newData[index - 1].LastModifiedDate).format("YYYY-MM-DD") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("pdf.pdf");
        setLoading(false);
      },
    });
  };

  const onBtPrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(data.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].DueDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(data[index - 1].LastModifiedDate).format("YYYY-MM-DD") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const handleexcelexport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formValues);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Transactionlog_details_.xlsx`);
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission("edit-transaction-log") &&
    row?.original?.Module === "SALES" ? (
      <MenuItem onClick={() => navigate(`/manage-sales/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "RECEIVINGS" ? (
      <MenuItem
        onClick={() => navigate(`/manage-receiving/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "DEPOSIT" ? (
      <MenuItem onClick={() => navigate(`/bank-deposit/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "TRANSFER" ? (
      <MenuItem onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "JOURNAL" ? (
      <MenuItem onClick={() => navigate(`/journal-entry/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "PAYBILLS" ? (
      <MenuItem
        onClick={() => navigate(`/receiving-paybills/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "RECEIVEPAYMENT" ? (
      <MenuItem onClick={() => navigate(`/receive-payment/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
        (checkUserPermission("mark-inactive") ? (
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            //only export selected rows
            onClick={() =>
              handleDeletePopup(
                "",
                "",
                table.getSelectedRowModel().rows,
                "multipleRowInactive"
              )
            }
            // startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Mark InActive
          </Button>
        ) : (
          " "
        ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  console.log(loading, "data1039");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          {/* Header Scetion */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Accounting: Transaction Log</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Transaction Log</li>
              </ul>
            </div>
            {/* export Print arrange Columns */}
          </div>

          {/* Filter Section */}
          <div className="card">
            <div className="card-body">
              {/* First Row */}
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                }}
              >
                {/* 1st Filter */}
                <div
                  className="col-md-10"
                  style={{ display: "flex", gap: "1rem" }}
                >
                  {/* Date Filter */}
                  <div className=" col-md-2" style={{ width: "fit-content" }}>
                    <div className=" col-form-label"> Date: </div>
                    <Select
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      // isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      // hideSelectedOptions={true}
                      // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      isOptionDisabled={(option) => option.value == 0}
                      className="custom-search-select"
                    />
                  </div>
                  {/* From Date */}
                  <div className="col-md-2">
                    <div className=" col-form-label"> From: </div>
                    <CommonDatePicker FinalDate={beginningDate} handleDateChange={handleDate}/>
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={
                        moment(beginningDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                      // value={beginningDate}
                      onChange={(event) => handleDate(event)}
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                    {/* <Flatpickr
  type="date"
  className="form-control form-control-sm"
  id="StartDate"
  name="StartDate"
  value={moment(beginningDate).format('YYYY-MM-DD')}
  onChange={(date) => handleDate(date)} // 'date' will be a Date object
  options={{
    dateFormat: "m/d/Y",
    altInput: true,
    altFormat: "m/d/Y",
  }}
/> */}
                  </div>

                  {/* To Date */}
                  <div className="col-md-2">
                    <div className=" col-form-label">To: </div>

                    
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      // value={finalDate}
                      value={
                        moment(finalDate).format("YYYY-MM-DDT00:00:00.000") +
                        "Z"
                      }
                      onChange={(event) => handleEndDate(event)}
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                     <CommonDatePicker FinalDate={finalDate} handleDateChange={handleEndDate}/>
                  </div>

                  <div className="col-md-2">
                    <div className=" col-form-label">Transaction Type:</div>
                    <Select
                      options={transactionTypeDropdownOption}
                      value={transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )}
                      onChange={(event) => {
                        selectTransactionHandle(event?.value);
                      }}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="Transaction"
                      name="Transaction"
                      className="custom-search-select"
                    />
                  </div>
                  <div className="col-md-2">
                    <div className="col-form-label">
                      <input
                        type="radio"
                        onClick={(e) => radioClickSupplierHandle(e)}
                        checked={showSupplierSelect}
                        style={{ fontSize: "1rem" }}
                      />{" "}
                      Supplier
                    </div>

                    <div className="col-form-label">
                      <input
                        type="radio"
                        onClick={(e) => radioClickCustomerHandle(e)}
                        checked={showCustomerSelect}
                        style={{ fontSize: "1rem" }}
                      />{" "}
                      Customer
                    </div>

                    {selectTransaction == 6 && (
                      <div className="col-form-label">
                        <input
                          type="radio"
                          onClick={(e) => radioClickempolyeHandle(e)}
                          checked={ShowEmployeeSelect}
                          style={{ fontSize: "1rem" }}
                        />{" "}
                        Employees
                      </div>
                    )}
                  </div>

                  {/* Supplier Filter */}
                  {showSupplierSelect && (
                    <div className="col-md-3">
                      <div className="col-form-label"> Supplier </div>
                      <Select
                        options={supplierTypeDropdownOption}
                        value={supplierTypeDropdownOption.find(
                          (option) => option?.value == selectSupplier
                        )}
                        onChange={(event) => {
                          selectSupplierHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        // isClearable={true}
                        // filterOption={customFilterOption}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                        // defaultInputValue="Select Supplier..."
                        // isOptionDisabled={(option) => option.value == 0}
                      />
                    </div>
                  )}

                  {/* Customer Filter */}
                  {showCustomerSelect && (
                    <div className="col-md-3">
                      <div className=" col-form-label">Customer</div>
                      <Select
                        options={customerOption}
                        value={customerOption.find(
                          (option) => option?.value == selectCustomer
                        )}
                        onChange={(event) => {
                          selectCustomerHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        // filterOption={customFilterOption}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                        // isOptionDisabled={(option) => option.value == 0}
                        // defaultInputValue="Select Customer..."
                      />
                    </div>
                  )}

                  {ShowEmployeeSelect && (
                    <div className="col-md-3">
                      <div className=" col-form-label">Employees</div>
                      <Select
                        options={EmployeesOption}
                        value={EmployeesOption.find(
                          (option) => option?.value == selectEmployee
                        )}
                        onChange={(event) => {
                          selectEmployeeHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        // filterOption={customFilterOption}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Employees"
                        name="Employees"
                        className="custom-search-select"
                        // isOptionDisabled={(option) => option.value == 0}
                        // defaultInputValue="Select Customer..."
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Data Table  */}
          <div className="card">
            <div className="card-body">
              <div
                className="row"
                style={{
                  margin: "10px",
                  display: "flex",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "16px",
                  }}
                  className="col-md-10"
                >
                  <div>
                    Search:{" "}
                    {
                      transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )?.label
                    }
                  </div>
                  <div>
                    {formValues?.length > 0 ? (
                      <> Found {formValues[0]?.TotalRecord} matches.</>
                    ) : (
                      "No items found."
                    )}
                  </div>
                  <div>
                    {beginningDate && (
                      <>
                        From: {moment(beginningDate).format('MM/DD/YYYY')}{" "}
                        {finalDate != "" && <>To:{' '} {moment(finalDate).format('MM/DD/YYYY')}</>}{" "}
                      </>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    alignItems: "center",
                  }}
                  className="col-md-2"
                >
                  {checkUserPermission("export-button") ? (
                    <button
                      // className="btn btn-added pull-right"
                      className="btn btn-sm btn-outline-dark btn-sm mt-3"
                      style={{ width: "max-content" }}
                      onClick={() => onBtExport([], "AllData")}
                    >
                      <i
                        className="fa fa-download mr-2"
                        style={{ color: "#111930" }}
                      ></i>
                      Export Visible Column
                      {/* <i class="fa-thin fa-download"></i> */}
                    </button>
                  ) : (
                    ""
                  )}

                  <div
                    className="cursor-pointer mt-3 mr-3"
                    onClick={() =>
                      handleSaveColumnOrder(
                        loginuserid,
                        "TransactionLog",
                        columnOrder,
                        token,
                        columnVisibility
                      )
                    }
                    title="Lock Your Sequence"
                    // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                    // onMouseLeave={() => setIcon(ColumnOrderIcon)}
                  >
                    <i class="fa fa-lock columnsLock fs-4"></i>
                  </div>
                </div>
              </div>

         <div style={{position:"relative" , zIndex:"0"}}>

         <CommonMatrialReactTableServerSideRender
                MainHeading="Sonar POS"
                ReportHeading="Payment List"
                columns={columns}
                data={data}
                // startdate={startdate}
                // enddate={enddate}
                columnGrouping={[]}
                columnsVisibility={{}}
                enableRowActions={checkUserPermission(PERMISSION_EDIT)}
                enableRowSelection={true}
                renderRowActionMenuItems={renderRowActionMenuItems}
                renderTopToolbarCustomActions={renderTopToolbarCustomActions}
                density="comfortable"
                showGlobalFilter={true}
                showColumnFilters={false}
                expanded={true}
                pagination={{ pageIndex: 0, pageSize: 25 }}
                rowCount={rowCount}
                setColumnFilters={setColumnFilters} // for termp comment filteron column
                setGlobalFilter={setGlobalFilter}
                setPagination={setPagination}
                setSorting={setSorting}
                setColumnOrder={setColumnOrder}
                setColumnVisibility={setColumnVisibility} //setColumnVisibility
                state={{
                  columnFilters, // for termp comment filteron column
                  // globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                  columnOrder,
                  columnVisibility,
                }}
              />
         </div>

              {/* <MaterialReactTable
                columns={columns}
                data={data}
                enableColumnResizing
                enableRowActions={checkUserPermission("edit-transaction-log")}
                positionGlobalFilter="left"
                renderRowActionMenuItems={({ row }) => [
                  checkUserPermission("edit-transaction-log") &&
                  row?.original?.Module === "SALES" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-sales/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "RECEIVINGS" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-receiving/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "DEPOSIT" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/bank-deposit/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "TRANSFER" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-transfer/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "JOURNAL" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/journal-entry/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "PAYBILLS" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/receiving-paybills/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "RECEIVEPAYMENT" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/receive-payment/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : (
                    ""
                  ),
                ]}
                enableGrouping
                enableStickyHeader
                enableStickyFooter
                enableRowSelection
                enableColumnOrdering
                initialState={{
                  density: "comfortable",
                  showGlobalFilter: true,
                  expanded: true, //expand all groups by default
                  // grouping: [""], //an array of columns to group by by default (can be multiple)
                  pagination: { pageIndex: 0, pageSize: 25 },
                  // sorting: [{ id: "state", desc: false }], //sort by state by default
                }}
                // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

                //For color of each alternative row(Zebra-column)
                muiTableBodyProps={{
                  sx: () => ({
                    "& tr:nth-of-type(even)": {
                      backgroundColor: "var(--datatable-row-background-color)",
                      //'rgb(237 237 233 / 63%)'
                    },
                    "& td": {
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },

                    "& tr": {
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },
                  }),
                }}
                muiPaginationProps={{
                  rowsPerPageOptions: [25, 50, 100, 300, 500],
                }}
                muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                // For providing color to header of table
                muiTableHeadCellProps={{
                  sx: (theme) => ({
                    background: "var(--datatable-row-background-color)", //'#e9e9e9',
                    borderRight:
                      "1px solid var(--datatable-row-background-hover-color)",
                    lineHeight: "16px",
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "var(--primary-color-800)",
                    fontFamily: "Inter",
                  }),
                }}
                manualFiltering
                manualPagination
                manualSorting
                muiToolbarAlertBannerProps={
                  // isError
                  // ? {
                  //   color: "error",
                  //   children: "Error loading data",
                  // }
                  // : undefined
                  {
                    isError: () => ({
                      color: "error",
                      children: "Error loading data",
                    }),
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }
                }
                muiSelectCheckboxProps={{
                  sx: (theme) => ({
                    lineHeight: "16px",
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "var(--prinary-color-800)",
                    fontFamily: "Inter",
                  }),
                }}
                muiSelectAllCheckboxProps={{
                  sx: (theme) => ({
                    lineHeight: "16px",
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "var(--prinary-color-800)",
                    fontFamily: "Inter",
                  }),
                }}
                onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                rowCount={totalRows}
                state={{
                  columnFilters,
                  // globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    {(table.getIsSomeRowsSelected() ||
                      table.getIsAllRowsSelected()) && (
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleexcelexport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                    )}
                    {(table.getIsSomeRowsSelected() ||
                      table.getIsAllRowsSelected()) && (
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                    )}
                    {(table.getIsSomeRowsSelected() ||
                      table.getIsAllRowsSelected()) && (
                      <Button
                        // size="small"
                        // color="primary"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "allData")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                    )}
                    {(table.getIsSomeRowsSelected() ||
                      table.getIsAllRowsSelected()) && (
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedRow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                    )}
                    {(table.getIsSomeRowsSelected() ||
                      table.getIsAllRowsSelected()) && (
                      <Button
                        // color="primary"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        variant="contained"
                        onClick={() => onBtPrint()}
                      >
                        Print PDF
                      </Button>
                    )}
                    {/* <Button
                      size="small"
                      onClick={() =>
                        setPagination({ ...pagination, pageSize: totalRows })
                      }
                      variant="contained"
                    >
                      Get All Data
                    </Button> */}
              {/* </Box>
                )}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentLog;
